import { Icon } from '@aloft/toolkit-sui';

import { setMobileReferenceMenuOpen } from '../../redux/features/referenceBarUISlice.js';
import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.js';
import { selectDeviceWidth } from '../../redux/features/selectors/uiSelectors.js';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.js';

export const Tkv2ReferenceBarMobileToggle = () => {
  const deviceWidth = useAppSelector(selectDeviceWidth);
  const { mobileReferenceMenuOpen } = useAppSelector(selectReferenceBarUI);
  const dispatch = useAppDispatch();

  if (deviceWidth !== 'phone') {
    return null;
  }

  return (
    <div
      className="reference-bar-mobile-toggle"
      onClick={() => dispatch(setMobileReferenceMenuOpen(!mobileReferenceMenuOpen))}
    >
      <Icon icon="home-heart" variant="outlined" size="lg" color="buttonDefault" />
    </div>
  );
};
